<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableReservedInstancePurchaseDate"
      style="width: 100.1%;"
    ></Table>
    <!-- 操作日志详情 -->
    <configuration-management-operation-log
      v-if="isShowOperationLog"
      ref="configurationManagementOperationLog"
    ></configuration-management-operation-log>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import ConfigurationManagementOperationLog from "../../common/ConfigurationManagementOperationLog.vue";

var tableReservedInstancePurchaseVue = {};
export default {
  name: "TableReservedInstancePurchase",
  components: {
    ConfigurationManagementOperationLog
  },
  data() {
    return {
      isShowOperationLog: false,
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      editIndex: -1,
      editPurchaseSize: "",
      columns: [
        {
          title: this.$t(
            "configuration_management.reserved_instance_purchase.riFamily"
          ),
          key: "riFamilyType"
        },
        {
          title: this.$t(
            "configuration_management.reserved_instance_purchase.size"
          ),
          key: "purchaseSize",
          render: (h, { row, index }) => {
            let edit;
            if (tableReservedInstancePurchaseVue.editIndex === index) {
              this.editPurchaseSize = row.purchaseSize;
              let options = row.instanceTypeSizes.map(v => {
                return h(
                  "Option",
                  {
                    props: {
                      value: v.value
                    },
                    directives: [
                      {
                        name: "hasPermission",
                        value: new Array(
                          "configurationManagement:reservedInstancePurchase:update"
                        )
                      }
                    ]
                  },
                  v.key
                );
              });
              edit = [
                h(
                  "Select",
                  {
                    props: {
                      value: row.purchaseSize,
                      transfer: true
                    },
                    on: {
                      "on-change": val => {
                        this.editPurchaseSize = val;
                      }
                    },
                    directives: [
                      {
                        name: "hasPermission",
                        value: new Array(
                          "configurationManagement:reservedInstancePurchase:update"
                        )
                      }
                    ]
                  },
                  options
                )
              ];
            } else {
              edit = row.purchaseSize;
            }
            return h("div", [edit]);
          }
        },
        {
          title: this.$t("common.operationLog"),
          slot: "delete",
          fixed: "right",
          minWidth: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.rowClick(params.row);
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "configurationManagement:reservedInstancePurchase:log"
                      )
                    }
                  ]
                },
                this.$t("common.operationLog")
              )
            ]);
          }
        },
        {
          title: this.$t("common.operation"),
          render: (h, { row, index }) => {
            if (tableReservedInstancePurchaseVue.editIndex === index) {
              return [
                h(
                  "Button",
                  {
                    props: {
                      type: "success",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.tableReservedInstancePurchaseDate[
                          index
                        ].purchaseSize = this.editPurchaseSize;
                        tableReservedInstancePurchaseVue.editIndex = -1;

                        var editList = {
                          id: row.id,
                          purchaseSize: this.editPurchaseSize
                        };

                        // 编辑接口
                        this.$api.purchaseRiFamilySize
                          .update(editList)
                          .then(res => {
                            setTimeout(() => {
                              tableReservedInstancePurchaseVue.getData();
                              this.$Message.success("编辑成功");
                            }, 1000);
                          });
                      }
                    }
                  },
                  this.$t("configuration_management.common.save")
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    style: {
                      marginLeft: "6px"
                    },
                    on: {
                      click: () => {
                        tableReservedInstancePurchaseVue.editIndex = -1;
                        tableReservedInstancePurchaseVue.getData();
                      }
                    }
                  },
                  this.$t("alarms.common.cancel")
                )
              ];
            } else {
              return h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.editPurchaseSize = row.purchaseSize;
                      tableReservedInstancePurchaseVue.editIndex = index;
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "configurationManagement:reservedInstancePurchase:update"
                      )
                    }
                  ]
                },
                this.$t("common.edit")
              );
            }
          }
        }
      ],
      tableReservedInstancePurchaseDate: []
    };
  },
  beforeCreate: function() {
    tableReservedInstancePurchaseVue = this;
  },
  mounted: function() {
    tableReservedInstancePurchaseVue.getData();
  },
  methods: {
    showAll: function() {
      tableReservedInstancePurchaseVue.editIndex = -1;
      tableReservedInstancePurchaseVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      //分页
      this.$api.purchaseRiFamilySize
        .pagingQuery({
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableReservedInstancePurchaseDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      // change时行内编辑取消
      tableReservedInstancePurchaseVue.editIndex = -1;
      this.current = current;
      tableReservedInstancePurchaseVue.getData();
    },
    changeSize: function(pageSize) {
      // change时行内编辑取消
      tableReservedInstancePurchaseVue.editIndex = -1;
      this.pageSize = pageSize;
      tableReservedInstancePurchaseVue.getData();
    },
    // 操作日志
    rowClick: function(row) {
      this.isShowOperationLog = true;
      this.$nextTick(function() {
        this.$refs.configurationManagementOperationLog.getConfigurationManagementOperationLogList(
          row.id,
          16
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/reserved_instance_purchase/TableReservedInstancePurchase.vue